import vectorStr from "!!raw-loader!..\\..\\..\\..\\content\\blog\\data-structure-algorithm\\vector.ts";
import linkStr from "!!raw-loader!..\\..\\..\\..\\content\\blog\\data-structure-algorithm\\link.ts";
import stackQueueStr from "!!raw-loader!..\\..\\..\\..\\content\\blog\\data-structure-algorithm\\stack-queue.ts";
import binarytreeStr from "!!raw-loader!..\\..\\..\\..\\content\\blog\\data-structure-algorithm\\binary-tree.ts";
import React from 'react';
export default {
  vectorStr,
  linkStr,
  stackQueueStr,
  binarytreeStr,
  React
};